// 학원 공통 정보
export const SITE = {
  name: '이든 영어학원',
  nameEn: 'Eden English Academy',
  phone: '02-5678-9012',
  email: 'info@eden-academy.com',
  address: '서울시 강남구 테헤란로 456',
  addressDetail: '이든빌딩 3층',
  kakao: 'https://pf.kakao.com/',
  hours: [
    { day: '평일', time: '10:00 - 22:00' },
    { day: '토요일', time: '09:00 - 18:00' },
    { day: '일요일', time: '휴무' },
  ],
};

export const LEVELS = {
  beginner: { name: '초급', en: 'Beginner', dot: 'bg-emerald-500', chip: 'bg-emerald-50 text-emerald-700' },
  intermediate: { name: '중급', en: 'Intermediate', dot: 'bg-sky-500', chip: 'bg-sky-50 text-sky-700' },
  advanced: { name: '고급', en: 'Advanced', dot: 'bg-violet-500', chip: 'bg-violet-50 text-violet-700' },
} as const;
